/**
 * Capitalize the first letter of a word.
 * @param word
 */
export const capitalizeWord = (word: string): string => {
  if (isNullOrWhitespace(word)) return null;

  if (word != null) {
    word = word.charAt(0).toUpperCase() + word.slice(1);
    return word;
  } else {
    return '';
  }
};

/**
 * Check if a provided string is null or whitespace.
 * @param input
 */
export const isNullOrWhitespace = (input: string): boolean => {
  return !input || !input.trim();
};

/**
 * Given a string, that same string is made lowercase
 * and any trailing or leading whitespace and line terminators are removed.
 * @param input
 */
export const normalizeString = (input: string): string => {
  if (isNullOrWhitespace(input)) return null;

  return input.toLowerCase().trim();
};

/**
 * Determines whether a string has any letters in it.
 * @param input
 */
export const stringHasLetters = (input: string): boolean => /\D/.test(input);
